import { render, staticRenderFns } from "./AccettazioneSsnGruppiConfigListComponent.vue?vue&type=template&id=38d48b06&scoped=true"
import script from "./AccettazioneSsnGruppiConfigListComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnGruppiConfigListComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnGruppiConfigListComponent.vue?vue&type=style&index=0&id=38d48b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d48b06",
  null
  
)

export default component.exports